// Origen del backend sin /api al final. `axiosconf` añade `/api` en baseURL.
// Si REACT_APP_API_URL ya incluye `/api`, quitarlo para no generar `/api/api/...` (404).
let rawApiOrigin = (process.env.REACT_APP_API_URL || 'http://localhost:8000').replace(/\/+$/, '');
rawApiOrigin = rawApiOrigin.replace(/\/api$/i, '');
export const baseUrlCSRFCookie = rawApiOrigin;
export const baseUrl = `${rawApiOrigin}/api`;

/**
 * Prefijo de ruta donde está montada la SPA (ej. '' si la URL es /#/..., '/smile' si es /smile/#/...).
 * Sirve para armar URLs con hash en window.open sin usar process en runtime (evita errores con SES/extensiones).
 */
export function getSpaPathPrefix() {
    if (typeof window === 'undefined') return '';
    return window.location.pathname.replace(/\/$/, '');
}